<div [ngClass]="'sidebar-' + position()">
    <nav class="nav">        
        <ng-content></ng-content>  
    </nav>
</div>
<svg
style="visibility: hidden; position: absolute;"
width="0"
height="0">
<defs>
    <!-- Filter for left and right sidebars -->
    <filter id="nav_filter_blur_side" x="-20%" y="-20%" width="140%" height="140%" filterUnits="objectBoundingBox" color-interpolation-filters="sRGB">
        <feFlood flood-opacity="0" result="BackgroundImageFix"/>
        <feGaussianBlur in="BackgroundImageFix" stdDeviation="4"/>
        <feComposite in2="SourceAlpha" operator="in" result="effect1_backgroundBlur_7731_46058"/>
        <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
        <feOffset dy="4"/>
        <feGaussianBlur stdDeviation="10"/>
        <feComposite in2="hardAlpha" operator="out"/>
        <feColorMatrix type="matrix" values="0 0 0 0 0.113725 0 0 0 0 0.32549 0 0 0 0 0.643137 0 0 0 0.32 0"/>
        <feBlend mode="normal" in2="effect1_backgroundBlur_7731_46058" result="effect2_dropShadow_7731_46058"/>
        <feBlend mode="normal" in="SourceGraphic" in2="effect2_dropShadow_7731_46058" result="shape"/>
    </filter>

    <!-- Filter for top sidebar -->
    <filter id="nav_filter_blur_top" x="-5%" y="-50%" width="110%" height="300%" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
        <feFlood flood-opacity="0" result="BackgroundImageFix"/>
        <feGaussianBlur in="BackgroundImageFix" stdDeviation="4"/>
        <feComposite in2="SourceAlpha" operator="in" result="effect1_backgroundBlur_7731_46058"/>
        <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
        <feOffset dy="4"/>
        <feGaussianBlur stdDeviation="10"/>
        <feComposite in2="hardAlpha" operator="out"/>
        <feColorMatrix type="matrix" values="0 0 0 0 0.113725 0 0 0 0 0.32549 0 0 0 0 0.643137 0 0 0 0.32 0"/>
        <feBlend mode="normal" in2="effect1_backgroundBlur_7731_46058" result="effect2_dropShadow_7731_46058"/>
        <feBlend mode="normal" in="SourceGraphic" in2="effect2_dropShadow_7731_46058" result="shape"/>
    </filter>
</defs>
</svg>
